"use strict";

require("core-js/modules/es6.array.index-of");

var _slicedToArray = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useBrowser;

var _react = require("react");

var _ismobilejs = _interopRequireDefault(require("ismobilejs"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function useBrowser() {
  var _ref = (0, _react.useState)({
    wallet: false,
    wechat: false,
    mobile: {
      apple: {
        phone: false,
        ipod: false,
        tablet: false,
        device: false
      },
      amazon: {
        phone: false,
        tablet: false,
        device: false
      },
      android: {
        phone: false,
        tablet: false,
        device: false
      },
      windows: {
        phone: false,
        tablet: false,
        device: false
      },
      other: {
        blackberry: false,
        blackberry10: false,
        opera: false,
        firefox: false,
        chrome: false,
        device: false
      },
      phone: false,
      tablet: false,
      any: false
    }
  }),
      _ref2 = _slicedToArray(_ref, 2),
      browser = _ref2[0],
      setBrowser = _ref2[1];

  (0, _react.useEffect)(function () {
    var isWallet = navigator.userAgent.indexOf('ABTWallet') > -1;
    var isWechat = /MicroMessenger/i.test(navigator.userAgent);
    setBrowser({
      wallet: isWallet,
      wechat: isWechat,
      mobile: (0, _ismobilejs["default"])(navigator.userAgent)
    });
  }, []);
  return browser;
}